<template>
  <div>
    <b-row>
      <b-col>
        <div class="page-subtitle mt-5 mb-4">Audit Logs</div>
        <p class="text-muted mb-0">
          View activity for your company: logins, changes, and other recorded
          events. Use filters to narrow the list.
        </p>
      </b-col>
    </b-row>
    <company-audit-log-list class="mt-4" />
  </div>
</template>

<script>
import CompanyAuditLogList from '../lists/CompanyAuditLogList.vue'

export default {
  components: {
    CompanyAuditLogList,
  },
}
</script>

<style scoped>
/* Scale the section heading spacing so it starts compact on phones and builds
   up to the current desktop value. */
@media (max-width: 575.98px) {
  .page-subtitle.mt-5 {
    margin-top: 1.25rem !important;
  }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .page-subtitle.mt-5 {
    margin-top: 2rem !important;
  }
}
</style>
